/* eslint-disable standard/no-callback-literal */
import auth from "@/modules/auth/services/auth";
import axios from "axios";
import router from "@/modules/global/router";
import store from "@/modules/global/stores";
// eslint-disable-next-line no-unused-vars

var http = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token")
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    }
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        })
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        })
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                })
                .catch(function (err) {
                    var failedRequest = err.config;
                    // eslint-disable-next-line no-undef
                    var token = JSON.parse(localStorage.getItem("token")).value;
                    auth.doLogout(token, function (result) {
                        if (result.success) {
                            localStorage.clear();
                            store.commit("auth_destroyed");
                            router.push("/");
                        }
                    });

                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    }
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function addTheme(data, callback) {
    var config = getConfig();

    http.post("ambis-test/admin/theme", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editTheme(theme_id, data, callback) {
    var config = getConfig();

    http.put(`ambis-test/admin/theme/${theme_id}`, data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListTheme(params, callback) {
    var config = getConfig();

    http.get("ambis-test/admin/theme/list", {
        params: {
            page: params.page,
            size: params.size,
            theme_name: params.theme_name,
            theme_description: params.theme_description,
            target_user: params.target_user,
        },
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailTheme(theme_id, callback) {
    var config = getConfig();

    http.get(`ambis-test/admin/theme/${theme_id}`, {
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListScale(theme_id, params, callback) {
    var config = getConfig();

    http.get(`ambis-test/admin/scale/list/${theme_id}`, {
        params: {
            page: params.page,
            size: params.size,
            scale_name: params.scale_name,
            // question_type: params.question_type,
            // status: params.scale_status,
        },
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailScale(scale_id, callback) {
    var config = getConfig();

    http.get(`ambis-test/admin/scale/${scale_id}`, {
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addScale(data, callback) {
    var config = getConfig();

    http.post("ambis-test/admin/scale", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editScale(scale_id, data, callback) {
    var config = getConfig();

    http.put(`ambis-test/admin/scale/${scale_id}`, data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addQuestion(scale_id, data, callback) {
    var config = getConfig();

    http.post(`ambis-test/admin/question/${scale_id}`, data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editQuestion(question_id, scale_id, data, callback) {
    var config = getConfig();

    http.put(
        `ambis-test/admin/question/${question_id}/${scale_id}`,
        data,
        config
    )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListQuestion(scale_id, callback) {
    var config = getConfig();

    http.get(`ambis-test/admin/question/${scale_id}/list`, {
        params: {},
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function detailQuestion(question_id, callback) {
    var config = getConfig();

    http.get(`ambis-test/admin/question/${question_id}/detail`, {
        params: {},
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListInterpretasi(scale_id, callback) {
    var config = getConfig();

    http.get(`ambis-test/admin/interpretation/${scale_id}/list`, {
        params: {},
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addRange(data, callback) {
    var config = getConfig();

    http.post("ambis-test/admin/interpretation", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editRange(intrepretation_id, data, callback) {
    var config = getConfig();

    http.put(
        `ambis-test/admin/interpretation/${intrepretation_id}`,
        data,
        config
    )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addSubInterpretation(interpretation_id, data, callback) {
    var config = getConfig();

    http.post(
        `ambis-test/admin/subinterpretation/${interpretation_id}`,
        data,
        config
    )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editSubInterpretation(subintrepretation_id, data, callback) {
    var config = getConfig();

    http.put(
        `ambis-test/admin/subinterpretation/${subintrepretation_id}`,
        data,
        config
    )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailSubInterpretation(subinterpretation_id, callback) {
    var config = getConfig();

    http.get(`ambis-test/admin/subinterpretation/${subinterpretation_id}`, {
        params: {},
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteTheme(id, callback) {
    var config = getConfig();
    http.delete(`ambis-test/admin/theme/${id}`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function deleteScale(id, callback) {
    var config = getConfig();
    http.delete(`ambis-test/admin/scale/${id}`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function deleteQuestion(id, callback) {
    var config = getConfig();
    http.delete(`ambis-test/admin/question/${id}`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function deleteInterpretation(id, callback) {
    var config = getConfig();
    http.delete(`ambis-test/admin/interpretation/delete/${id}`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function deleteSubInterpretation(id, callback) {
    var config = getConfig();
    http.delete(`ambis-test/admin/subinterpretation/${id}`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: true,
                message: error.message,
            });
        });
}

function addCTA(data, callback) {
    var config = getConfig();

    http.post(`ambis-test/admin/cta`, data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editCTA(id, data, callback) {
    var config = getConfig();

    http.put(`ambis-test/admin/cta/${id}`, data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteCTA(id, callback) {
    var config = getConfig();

    http.delete(`ambis-test/admin/cta/${id}`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateStatusScale(data, callback) {
    var config = getConfig();

    http.put(`ambis-test/admin/scale/${data.status}/${data.id}`, "", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getPotentialIntelligences(callback) {
    var config = getConfig();

    http.get(`ambis-test/admin/potentialIntelligences`, {
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addPotentialIntelligences(data, callback) {
    var config = getConfig();

    http.post(`ambis-test/admin/potentialIntelligences`, data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editPotentialIntelligences(id, data, callback) {
    var config = getConfig();

    http.put(`ambis-test/admin/potentialIntelligences/${id}`, data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deletePotentialIntelligences(id, callback) {
    var config = getConfig();

    http.delete(`ambis-test/admin/potentialIntelligences/${id}`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteBundle(id, callback) {
    var config = getConfig();

    http.delete(`ambis-test/test-tryouts/${id}`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailBundle(test_id, callback) {
    var config = getConfig();

    http.get(`ambis-test/test-tryouts/${test_id}`, {
        headers: config.headers,
    })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addBundle(data, callback) {
    var config = getConfig();

    http.post("ambis-test/test-tryouts", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function editBundle(test_id, data, callback) {
    var config = getConfig();

    http.put(`ambis-test/test-tryouts/${test_id}`, data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    addTheme,
    editTheme,
    getDetailTheme,
    getListTheme,
    getDetailScale,
    getListScale,
    addScale,
    editScale,
    getListQuestion,
    addQuestion,
    editQuestion,
    detailQuestion,
    getListInterpretasi,
    addRange,
    editRange,
    addSubInterpretation,
    editSubInterpretation,
    getDetailSubInterpretation,
    deleteTheme,
    deleteScale,
    deleteQuestion,
    deleteInterpretation,
    deleteSubInterpretation,
    addCTA,
    editCTA,
    updateStatusScale,
    deleteCTA,
    getPotentialIntelligences,
    addPotentialIntelligences,
    deletePotentialIntelligences,
    editPotentialIntelligences,
    deleteBundle,
    getDetailBundle,
    addBundle,
    editBundle
};



// WEBPACK FOOTER //
// ./src/modules/ambis_test/services/ambis_test.js